/**
 * used for customized file upload input fields
 **/
SUGApp.directive('passwordStrength', function(){
	return {
		templateUrl: '/js/directives/passwordStrength.html',
		restrict: 'EA',
		scope: {
			password: '@',
			password2: '@',
			styleoverride: '@'
		},
		controller: ['$scope','SUGUtilities', function($scope,SUGUtilities) {
			data = '';
			$scope.useglyph = 'remove';
			SUGUtilities.APISyncCall( "post", "", data, "c.getPasswordComplexity", 15000 )
				.then(function(r){
					var response = SUGUtilities.lowerCaseKeys(r.data);
					if(!response.success) {
						$scope.displayError(response.data.accountdetails.error,response.data.accountdetails.error_description,response.data.accountdetails.error_code);
					} else {
						$scope.passwordComplexity = response.data;
						$scope.passwordValid = {};
					}
				});

			function allTrue(obj){
				for(var o in obj)
				if(!obj[o]) {
					return false;
				}
				return true;
			};

			$scope.checkStrength = function(pass, pass2) {
				var passwordLenValue = pass ? $scope.password.length : 0;

				for (var ruletype in $scope.passwordComplexity){
					for (var rule in $scope.passwordComplexity[ruletype]) {
						$scope.passwordValid[rule] = false;
						if ($scope.passwordComplexity[ruletype][rule].enabled) {
							switch (rule) {
								case "minimum":
									$scope.passwordValid[rule] = passwordLenValue >= $scope.passwordComplexity[ruletype][rule].minvalue ? true : false;
									break;
								case "maximum":
									$scope.passwordValid[rule] = passwordLenValue <= $scope.passwordComplexity[ruletype][rule].maxvalue ? true : false;
									break;
								case "lower":
									var regexPattern = new RegExp($scope.passwordComplexity[ruletype][rule].pattern);
									$scope.passwordValid[rule] = regexPattern.test(pass) ? true : false;
									break;
								case "upper":
									var regexPattern = new RegExp($scope.passwordComplexity[ruletype][rule].pattern);
									$scope.passwordValid[rule] = regexPattern.test(pass) ? true : false;
									break;
								case "number":
									var regexPattern = new RegExp($scope.passwordComplexity[ruletype][rule].pattern);
									$scope.passwordValid[rule] = regexPattern.test(pass) ? true : false;
									break;
								case "specialchar":
									var regexPattern = new RegExp($scope.passwordComplexity[ruletype][rule].pattern);
									$scope.passwordValid[rule] = regexPattern.test(pass) ? true : false;
									break;
								case "recurring":
									var regexPattern = new RegExp($scope.passwordComplexity[ruletype][rule].pattern);
									$scope.passwordValid[rule] = regexPattern.test(pass) ? false : true;
									break;
							}

						}
					}
				}
				if (!allTrue($scope.passwordValid) || pass !== pass2) {
					return 'weak';
				} else if (allTrue($scope.passwordValid) && passwordLenValue < 10) {
					return 'medium';
				} else if (allTrue($scope.passwordValid) && passwordLenValue >= 10) {
					return 'strong';
				}
			}
		}],
		link: function($scope, element, attrs) {
			$scope.$watch( 'password', function() { 
				$scope.strengthValue = $scope.password ? $scope.checkStrength($scope.password, $scope.password2) : '';
				switch ($scope.strengthValue) {
					case 'weak':
						$scope.useglyph = 'remove';
						break;
					default:
						$scope.useglyph = 'ok';
						break;

				}
			});
		}
	};

});
